const VERSION = '1.0.2';

export default `//g.alicdn.com/ife/acm/${VERSION}/firebase.js`;



// WEBPACK FOOTER //
// ./src/const-res-url.js